<template>
    <div id="nav">
        <!-- <router-link to="/">Home</router-link> |
            <router-link to="/about">About</router-link> -->
    </div>
    <div class="modal" tabindex="-1" ref="messageDialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{dialog.title}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>{{dialog.message}}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">閉じる</button>
                    <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                </div>
            </div>
        </div>
    </div>
    <router-view/>
</template>

<script>
import googleOneTap from 'google-one-tap'
import utils from './utils/utils.js'
import {Modal} from 'bootstrap'

export default {
    setup() {
    },
    data() {
        return {
            modal: null,
            dialog: {title:null, message: null},
        }
    },
    methods: {
        async processGoogleOneTap(params){
            return new Promise((resolve) => {
                googleOneTap(params, (response) => {
                    resolve(response);
                });
            });
        },
        async googleLogin() {
            console.log("trying to google log in");
            let res = await this.processGoogleOneTap({
                client_id: '523312425777-n86434ubriukb3pg3ae80phn378k2jfg.apps.googleusercontent.com',
                auto_select: false,
                cancel_on_tap_outside: false,
                context: 'signin',
            });
            console.log("logged in");

            let token = res.credential;
            this.$store.commit('gToken', token);
        }
    },
    async mounted() {
        document.title="LIMAR"
        this.messageModal = new Modal(this.$refs.messageDialog);
        if(this.$store.state.gToken && !utils.isTokenExpired()) {
            console.log("already google logged in");
        } else {
            await this.googleLogin();
        }
    },
    async errorCaptured(err, vm, info) {
        console.log("ERROR----");
        console.log(err);
        console.log(vm);
        console.log(info);
        if(utils.isTokenExpired()){
            console.log("TRY RE-LOGIN");
            await this.googleLogin();
        } else {
            this.dialog = { title: "エラーが発生しました", message: err };
            this.messageModal.show();
        }
    },
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

#nav {
    padding: 1rem;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
</style>
